import { Api } from 'src/core/decorators/dto/api.decorator';
import { DtoHasApi } from 'src/core/models/shared/dto-has-api.model';
import { WrapUpOutcomePolicy } from 'src/core/models/wrap-up-definition/wrap-up-outcome-policy.enum';

// @Api route is the campaign configuration endpoint (`api/agentic-cx/campaign`), not the
// campaign-execution route the other campaign DTOs anchor.
@Api('api/agentic-cx/campaign')
export class CampaignAssignedWrapUpCode extends DtoHasApi {
  id = 0;
  name = '';
  policy: WrapUpOutcomePolicy = WrapUpOutcomePolicy.Completed;
}
